/**
 * Ambient engineering-sheet background: a faint fixed graticule that reads as
 * drafting paper / a schematic. Pure CSS (see `.drafting-grid` in index.css) —
 * no canvas, no rAF, no motion — so it costs nothing at runtime and needs no
 * reduced-motion handling. Decorative only; hidden from assistive tech.
 */
const DraftingGrid = (): JSX.Element => (
  <div className="drafting-grid" aria-hidden="true" />
);

export default DraftingGrid;
